/******************************************
 *  Author : Nikhil Unni
 *  Created On : Wed Oct 27 2021
 *  File : Types.js
 *******************************************/

export const GET_PATH_INFO_IV = 'GET_PATH_INFO_IV';